import {Grid, GridProps} from "@mantine/core";
import {useMemo} from "react";
import {dvirsSelector, TrailerEntity, useGetLatestTrailerDVIRsQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import { DVIRDataTable } from "../../data-table/DVIRDataTable/DVIRDataTable";
import { useApp } from "../../../providers/RegionProvider/RegionProvider";

export type TrailerDVIRViewProps = Omit<GridProps, 'children'> & {
  trailer: TrailerEntity
}

export const TrailerDVIRView = (props: TrailerDVIRViewProps) => {
  const {
    trailer,
    ...rest
  } = props

  const {regionId} = useApp()

  const selectDVIRs = useMemo(() => {
    return dvirsSelector();
  }, []);

  const arg = useMemo(() => {
    if (regionId) {
      return {
        regionId: regionId,
        trailerId: trailer.id,
      }
    } else {
      return skipToken
    }
  }, [regionId, trailer.id])

  const {dvirs, isLoading, isFetching} = useGetLatestTrailerDVIRsQuery(arg, {
    selectFromResult: (result) => ({
      dvirs: selectDVIRs(result),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
    })
  });

  return (
    <Grid {...rest}>
      <Grid.Col span={12}>
        <DVIRDataTable
          withBorder
          records={dvirs}
          recordsPerPageOptions={[10, 25, 50, 75, 100]}
          fetching={isLoading || isFetching}
        />
      </Grid.Col>
    </Grid>
  )
}
